(() => {
  if (customElements.get('bfg-size-guide')) return;
  const normalize = value => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const aliases = {'basic-tee':'basic-tee','basic-t-shirt':'basic-tee','basic-tshirt':'basic-tee','unisex-tee':'basic-tee','unisex-t-shirt':'basic-tee','unisex-tshirt':'basic-tee','t-shirt':'basic-tee','tshirt':'basic-tee','tee':'basic-tee','premium-tee':'premium-tee','premium-t-shirt':'premium-tee','premium-tshirt':'premium-tee','hawaiian-shirt':'hawaiian-shirt','hawaiian':'hawaiian-shirt','pullover-hoodie':'pullover-hoodie','hoodie':'pullover-hoodie','unisex-hoodie':'pullover-hoodie','sweatshirt':'sweatshirt','unisex-sweatshirt':'sweatshirt','crewneck-sweatshirt':'sweatshirt','crewneck':'sweatshirt'};
  customElements.define('bfg-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.styleSelect = this.querySelector('[data-style]');
      this.trigger = this.querySelector('.bfg-sg__trigger');
      this.trigger.addEventListener('click', () => {
        this.syncStyle();
        this.renderChart();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
      });
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.trigger.focus();
      });
      this.styleSelect.addEventListener('change', () => this.renderChart());
      this.querySelectorAll('input[type="radio"]').forEach(input => input.addEventListener('change', () => this.renderChart()));
      this.renderChart();
    }
    disconnectedCallback() {
      if (this.dialog?.open) document.documentElement.style.overflow = this.previousOverflow || '';
    }
    syncStyle() {
      const scope = this.closest('.product-infors') || this.closest('[id^="shopify-section-"]') || this.parentElement;
      let values = [];
      try { values = JSON.parse(this.dataset.selectedOptions || '[]'); } catch {}
      const selected = Array.from(scope.querySelectorAll('select[name="id"] option:checked')).map(option => option.textContent.trim().split(' / ')).flat();
      const checked = Array.from(scope.querySelectorAll('input:checked')).map(input => input.value);
      const active = Array.from(scope.querySelectorAll('.swatch .is-selected, .swatch .nt-swatch.is-selected, .swatch__list .is-selected, [aria-checked="true"]')).map(element => element.getAttribute('data-value') || element.textContent.trim());
      const match = [...active, ...checked, ...selected, ...values].map(value => aliases[normalize(value)]).find(key => key && Array.from(this.styleSelect.options).some(option => option.value === key));
      if (match) this.styleSelect.value = match;
    }
    renderChart() {
      const metric = this.querySelector('input[value="cm"]').checked;
      const label = this.querySelector(metric ? 'input[value="cm"]' : 'input[value="in"]').parentElement.textContent.trim();
      this.querySelectorAll('[data-chart]').forEach(panel => {
        panel.hidden = panel.dataset.chart !== this.styleSelect.value;
        panel.querySelector('[data-unit-label]').textContent = label;
        panel.querySelectorAll('[data-inches]').forEach(cell => {
          cell.textContent = (Number(cell.dataset.inches) * (metric ? 2.54 : 1)).toFixed(1);
        });
      });
    }
  });
})();
